export default __webpack_public_path__ + "static/B0091-0ae065a45babdeb6cec8d5d6b23557aa.png";